/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { bool, func, object } from 'prop-types';
import join from 'url-join';

import DateChangeModal from './DateChangeModal';
import StatusModal from '../../common/StatusModal';

import http from '../../../util/http';

import useModal from '../../../hooks/useModal';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

const DateChange = ({ isDateChangeModalOpen, closeDateChangeModal, selectedCatalogIds, refreshTableData }) => {
  const [isStatusModalOpen, openStatusModal, closeStatusModal] = useModal();
  const [statusModalProps, setStatusModalProps] = useState({ title: '' });

  const successModalProps = {
    type: 'success',
    title: 'Success:',
    message: 'Your date change was successfully submitted.'
  };

  const errorModalProps = {
    type: 'error',
    title: 'Error:',
    message: 'Your date change was unable to be submitted, please try again.'
  };

  const updateCatalogs = ({ catalogIds, dateData, resetForm }) =>
    http
      .patch(join(api2, `/catalogs?filter=id(${catalogIds})`), dateData)
      .then(() => {
        closeDateChangeModal();
        resetForm();
        refreshTableData();
        setStatusModalProps(successModalProps);
        openStatusModal();
      })
      .catch(() => {
        closeDateChangeModal();
        setStatusModalProps(errorModalProps);
        openStatusModal();
      });

  const submitDateChange = async (values, { setSubmitting, resetForm }) => {
    const catalogIds = Object.keys(selectedCatalogIds);

    const dateData = {};
    Object.entries(values).forEach(([key, value]) => {
      dateData[key] = value === '' ? null : value;
    });

    await updateCatalogs({ catalogIds, dateData, resetForm });
    setSubmitting(false);
  };

  return (
    <>
      <DateChangeModal
        isOpen={isDateChangeModalOpen}
        closeModal={closeDateChangeModal}
        submitDateChange={submitDateChange}
      />
      <StatusModal isOpen={isStatusModalOpen} closeModal={closeStatusModal} modalProps={statusModalProps} />
    </>
  );
};

DateChange.defaultProps = {
  selectedCatalogIds: null
};

DateChange.propTypes = {
  isDateChangeModalOpen: bool.isRequired,
  closeDateChangeModal: func.isRequired,
  selectedCatalogIds: object,
  refreshTableData: func.isRequired
};

export default DateChange;
